import { EUserPermissions } from '@zunta/configurations'

export enum EUserPermissionsCategory {
    FACILITY = 'Facility',
    RESIDENT = 'Resident',
    PAYMENTS = 'Payments',
    MAILINGS = 'Mailings',
    COLLECTIONS = 'Collections',
    USERS = 'Users',
    PERMISSIONS = 'Permissions'
}

export interface IUserPermissionItem {
    name: string,
    description: string,
    category: EUserPermissionsCategory,
    permission: EUserPermissions
}
